(function () {
  "use strict";

  function formatMoney(cents, currencyCodeEnabled) {
    var amount = cents / 100;
    var formattedAmount = amount.toFixed(2);
    var parts = formattedAmount.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    formattedAmount = parts.join(".");
    return window.shop_currency + " " + formattedAmount;
  }

  function formatMoneyDrawer(cents) {
    try {
      var amount = (parseInt(cents || 0, 10) / 100).toFixed(2);
      var parts = amount.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return window.shop_currency + " " + parts.join(".");
    } catch (e) {
      return window.shop_currency + " 0.00";
    }
  }

  function parseMoneyTextToCents(txt) {
    try {
      var m = (txt || "").match(/[\d'.,]+/);
      if (!m) return 0;
      var s = m[0].replace(/[']/g, "").replace(/,/g, "");
      return Math.round(parseFloat(s) * 100);
    } catch (e) {
      return 0;
    }
  }

  function saveDiscountPreference(discountTitle) {
    try {
      if (!discountTitle || discountTitle.trim() === "") {
        localStorage.setItem("activeDiscountTitle", "__no_discount__");
      } else {
        localStorage.setItem("activeDiscountTitle", discountTitle);
      }
    } catch (e) {
      console.error("[DEBUG] Error saving discount preference:", e);
    }
  }

  function getDiscountPreference() {
    try {
      var pref = localStorage.getItem("activeDiscountTitle");
      if (pref === "__no_discount__") {
        return "";
      }
      return pref || "";
    } catch (e) {
      console.error("[DEBUG] Error getting discount preference:", e);
      return "";
    }
  }

  function hasNoDiscountPreference() {
    try {
      return localStorage.getItem("activeDiscountTitle") === "__no_discount__";
    } catch (e) {
      console.error("[DEBUG] Error checking no-discount preference:", e);
      return false;
    }
  }

  function saveVariantDiscount(variantId, discountTitle, discountPercentage) {
    try {
      if (!variantId) {
        console.error("[DEBUG] saveVariantDiscount: No variantId provided");
        return;
      }
      var variantIdStr = String(variantId).trim();
      var variantDiscounts = {};
      var stored = localStorage.getItem("variantDiscounts");
      if (stored) {
        try {
          variantDiscounts = JSON.parse(stored);
        } catch (e) {
          console.error("[DEBUG] Error parsing stored variantDiscounts:", e);
          variantDiscounts = {};
        }
      }
      if (!discountTitle || discountTitle.trim() === "") {
        delete variantDiscounts[variantIdStr];
      } else {
        variantDiscounts[variantIdStr] = {
          title: discountTitle,
          percentage: discountPercentage || 0,
        };
      }
      localStorage.setItem(
        "variantDiscounts",
        JSON.stringify(variantDiscounts)
      );
    } catch (e) {
      console.error("[DEBUG] Error in saveVariantDiscount:", e);
    }
  }

  function getVariantDiscount(variantId) {
    try {
      var stored = localStorage.getItem("variantDiscounts");
      if (stored) {
        var variantDiscounts = JSON.parse(stored);
        var discount = variantDiscounts[variantId];
        if (discount) {
          return typeof discount === "string" ? discount : discount.title || "";
        }
      }
    } catch (e) {
      console.error("[DEBUG] Error getting variant discount:", e);
    }
    return "";
  }

  function getVariantDiscountData(variantId) {
    try {
      if (!variantId) {
        return null;
      }
      var variantIdStr = String(variantId).trim();
      var stored = localStorage.getItem("variantDiscounts");
      if (!stored) {
        return null;
      }
      var variantDiscounts = JSON.parse(stored);
      var discount = variantDiscounts[variantIdStr];
      if (discount && typeof discount === "object") {
        return discount;
      } else if (discount && typeof discount === "string") {
        return { title: discount, percentage: 0 };
      }
    } catch (e) {
      console.error("[DEBUG] Error in getVariantDiscountData:", e);
    }
    return null;
  }

  function getAssemblyPreference() {
    try {
      var lockedPreference = localStorage.getItem(
        "cartLockedDiscountPreference"
      );
      if (lockedPreference) {
        var lockedButtonNumber = parseInt(lockedPreference, 10);
        return lockedButtonNumber;
      }

      var preference = localStorage.getItem("assemblyPreference");
      return preference ? parseInt(preference, 10) : null;
    } catch (e) {
      console.error("[BUTTON] Error getting assembly preference:", e);
      return null;
    }
  }

  function isAssemblyBySkyPergola() {
    return getAssemblyPreference() === 2;
  }

  function calculateAndStoreButtonDiscountMapping(discounts) {
    try {
      if (!discounts || !Array.isArray(discounts) || discounts.length === 0) {
        return null;
      }

      var discountsWithPercentages = discounts
        .map(function (discount) {
          var percentage = 0;
          var discountValue = discount.value;

          if (discountValue) {
            if (discountValue.value !== undefined) {
              var value = parseFloat(discountValue.value);
              if (discountValue.type === "percentage") {
                if (value <= 1) {
                  percentage = value * 100;
                } else {
                  percentage = value;
                }
              } else {
                percentage = value * 100;
              }
            } else if (typeof discountValue === "number") {
              percentage =
                discountValue <= 1 ? discountValue * 100 : discountValue;
            } else if (typeof discountValue === "string") {
              var parsed = parseFloat(discountValue);
              percentage = parsed <= 1 ? parsed * 100 : parsed;
            }
          }

          return {
            title: discount.title || "",
            percentage: percentage,
            discount: discount,
          };
        })
        .sort(function (a, b) {
          return b.percentage - a.percentage;
        });

      if (discountsWithPercentages.length === 0) {
        return null;
      }

      var buttonMapping = {
        button1: discountsWithPercentages[0].title,
        button2:
          discountsWithPercentages.length >= 2
            ? discountsWithPercentages[1].title
            : discountsWithPercentages[0].title,
      };

      localStorage.setItem(
        "buttonDiscountMapping",
        JSON.stringify(buttonMapping)
      );

      return buttonMapping;
    } catch (e) {
      console.error("[BUTTON] Error calculating button discount mapping:", e);
      return null;
    }
  }

  function getButtonDiscountMapping() {
    try {
      var mapping = localStorage.getItem("buttonDiscountMapping");
      return mapping ? JSON.parse(mapping) : null;
    } catch (e) {
      console.error("[BUTTON] Error getting button discount mapping:", e);
      return null;
    }
  }

  function getDiscountForButton(buttonNumber, discounts) {
    try {
      if (!discounts || !Array.isArray(discounts) || discounts.length === 0) {
        return null;
      }

      var discountsWithPercentages = discounts
        .map(function (discount) {
          var percentage = 0;
          var discountValue = discount.value;

          if (discountValue) {
            if (discountValue.value !== undefined) {
              var value = parseFloat(discountValue.value);
              if (discountValue.type === "percentage") {
                if (value <= 1) {
                  percentage = value * 100;
                } else {
                  percentage = value;
                }
              } else {
                percentage = value * 100;
              }
            } else if (typeof discountValue === "number") {
              percentage =
                discountValue <= 1 ? discountValue * 100 : discountValue;
            } else if (typeof discountValue === "string") {
              var parsed = parseFloat(discountValue);
              percentage = parsed <= 1 ? parsed * 100 : parsed;
            }
          }

          return {
            title: discount.title || "",
            percentage: percentage,
            discount: discount,
          };
        })
        .sort(function (a, b) {
          return b.percentage - a.percentage;
        });

      if (discountsWithPercentages.length === 0) {
        return null;
      }

      if (buttonNumber === 1) {
        return discountsWithPercentages[0];
      } else if (buttonNumber === 2) {
        return discountsWithPercentages.length >= 2
          ? discountsWithPercentages[1]
          : discountsWithPercentages[0];
      }

      return null;
    } catch (e) {
      console.error("[BUTTON] Error getting discount for button:", e);
      return null;
    }
  }

  function cleanuplocalStorageForRemovedItems() {
    try {
      var hasDiscounts = localStorage.getItem("variantDiscounts");
      var hasRelationships = localStorage.getItem("variantRelationships");
      if (!hasDiscounts && !hasRelationships) {
        return;
      }

      fetch("/cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (cartData) {
          if (!cartData || !cartData.items || cartData.items.length === 0) {
            localStorage.removeItem("variantDiscounts");
            localStorage.removeItem("variantRelationships");
            localStorage.removeItem("cartLockedDiscountPreference");
            return;
          }

          var variantIdsInCart = [];
          cartData.items.forEach(function (item) {
            if (item.variant_id) {
              variantIdsInCart.push(String(item.variant_id));
            }
          });

          try {
            var variantDiscountsStr = localStorage.getItem("variantDiscounts");
            if (variantDiscountsStr) {
              var variantDiscounts = JSON.parse(variantDiscountsStr);
              var hasChanges = false;
              for (var variantId in variantDiscounts) {
                if (variantIdsInCart.indexOf(variantId) === -1) {
                  delete variantDiscounts[variantId];
                  hasChanges = true;
                }
              }
              if (hasChanges) {
                localStorage.setItem(
                  "variantDiscounts",
                  JSON.stringify(variantDiscounts)
                );
              }
            }
          } catch (e) {
            console.error("[CLEANUP] Error cleaning variantDiscounts:", e);
          }

          try {
            var variantRelationshipsStr = localStorage.getItem(
              "variantRelationships"
            );
            if (variantRelationshipsStr) {
              var variantRelationships = JSON.parse(variantRelationshipsStr);
              var hasChanges = false;
              for (var mainVariantId in variantRelationships) {
                if (variantIdsInCart.indexOf(mainVariantId) === -1) {
                  delete variantRelationships[mainVariantId];
                  hasChanges = true;
                }
              }
              if (hasChanges) {
                localStorage.setItem(
                  "variantRelationships",
                  JSON.stringify(variantRelationships)
                );
              }
            }
          } catch (e) {
            console.error("[CLEANUP] Error cleaning variantRelationships:", e);
          }

          try {
            var noDiscountStr = localStorage.getItem("noDiscountVariants");
            if (noDiscountStr) {
              var noDiscountVariants = JSON.parse(noDiscountStr);
              var filtered = noDiscountVariants.filter(function (variantId) {
                return variantIdsInCart.indexOf(variantId) !== -1;
              });
              if (filtered.length !== noDiscountVariants.length) {
                if (filtered.length === 0) {
                  localStorage.removeItem("noDiscountVariants");
                } else {
                  localStorage.setItem(
                    "noDiscountVariants",
                    JSON.stringify(filtered)
                  );
                }
              }
            }
          } catch (e) {
            console.error("[CLEANUP] Error cleaning noDiscountVariants:", e);
          }
        })
        .catch(function (error) {
          console.error("[CLEANUP] Error fetching cart:", error);
        });
    } catch (e) {
      console.error("[CLEANUP] Error in cleanup function:", e);
    }
  }

  window.formatMoney = formatMoney;
  window.formatMoneyDrawer = formatMoneyDrawer;
  window.parseMoneyTextToCents = parseMoneyTextToCents;
  window.saveDiscountPreference = saveDiscountPreference;
  window.getDiscountPreference = getDiscountPreference;
  window.hasNoDiscountPreference = hasNoDiscountPreference;
  window.saveVariantDiscount = saveVariantDiscount;
  window.getVariantDiscount = getVariantDiscount;
  window.getVariantDiscountData = getVariantDiscountData;
  window.getAssemblyPreference = getAssemblyPreference;
  window.isAssemblyBySkyPergola = isAssemblyBySkyPergola;
  window.calculateAndStoreButtonDiscountMapping =
    calculateAndStoreButtonDiscountMapping;
  window.getButtonDiscountMapping = getButtonDiscountMapping;
  window.getDiscountForButton = getDiscountForButton;
  window.cleanuplocalStorageForRemovedItems =
    cleanuplocalStorageForRemovedItems;
})();
